module.exports = __webpack_public_path__ + "static/media/logo.406f9d39.png";